<template>
  <div class="wrappers">
    <div class="homes">
       <van-search v-model="searchValue" placeholder="请输入搜索关键词" show-action @search="onSearchJ" class="mySearchs" enterkeyhint="search">
        <div slot="action" @click="onSearchJ"></div>
      </van-search>
      <div class="contentlist">
        <van-sidebar v-model="activeKey" :style="sidestyle">
          <van-sidebar-item v-for="(l, index) of schoollist" :key="l.category_id" :title="l.category" @click="(t)=>onChange(index)"/>
        </van-sidebar>
        <div class="contentarea" id="contentId">
          <template v-if="child">
            <div  class="contentline">{{ parentName }} - {{ child.category }}</div>
            <template v-if="infoList && infoList.length > 0">
              <div v-for="info of infoList" :key="info.id">
                <div class="vv-cardX"  @click="()=>openVideo(info)">
                  <div class="TSImageX">
                    <img :src="info.bg" />
                  </div>
                  <div class="TScontentX">
                    <div class="TStitleX">{{ info.title }}</div>
                    <div class="TSDescX" v-if="info.channel_type=='offcn'||info.channel_type=='zhuxue'||info.channel_type=='haixue'">
                      <span class="new-price">￥{{info.total_fee/100}}</span>
                    </div>
                    <div class="TSDescX" v-else>
                      <div  v-if="info.linktype!==8">{{`${info.file_total}节/${Number(info.duration/60).toFixed(0)}分钟`}}</div>
                    <!--  <div>{{`${info.learn_user_total || 1}人学过`}}</div>-->
                    </div>
                  </div>
                </div>
                <van-divider :style="{ margin: '2px 0px'}"/>
              </div>
            </template>
            <template v-else>
              <div class="contentline">
                该分类暂无课程
              </div>
            </template>
          </template>
          <template v-else-if="selectList">
            <van-dropdown-menu >
              <van-dropdown-item  title-class="myDropDownItem" v-model="selectValue" :options="selectOptions"  @change="changeSelcet"/>
            </van-dropdown-menu>
            <template v-if="infoList && infoList.length > 0">
              <div v-for="info of infoList" :key="info.id">
                <div class="vv-cardX"  @click="()=>openVideo(info)">
                  <div class="TSImageX">
                    <img :src="info.bg" />
                  </div>
                  <div class="TScontentX">
                    <div class="TStitleX">{{ info.title }}</div>
                    <div class="TSDescX" v-if="info.channel_type=='offcn'||info.channel_type=='zhuxue'||info.channel_type=='haixue'">
                      <span class="new-price">￥{{info.total_fee/100}}</span>
                    </div>
                    <div class="TSDescX" v-else>
                      <div  v-if="info.linktype!==8">{{`${info.file_total}节/${Number(info.duration/60).toFixed(0)}分钟`}}</div>
                      <!--<div>{{`${info.learn_user_total || 1}人学过`}}</div>-->
                    </div>
                  </div>
                </div>
                <van-divider :style="{ margin: '2px 0px'}"/>
              </div>
            </template>
            <template v-else>
              <div class="contentline">
                该分类暂无课程
              </div>
            </template>
          </template>
          <template v-else>
            <div v-for="a of listarea" :key="a.category_id" :class="a.category=='党员学习园地'||a.category=='党委中心组学习园地'||a.category=='积极分子学习园地'?'':'contentwrapper'"   >
              <div :class="a.category=='党员学习园地'||a.category=='党委中心组学习园地'||a.category=='积极分子学习园地'?'':'contentline'" >
                <!--{{ a.category }}-->
                <div style="padding: 0px 4px;margin-top: 5px;" v-if="a.category=='党员学习园地'||a.category=='党委中心组学习园地'||a.category=='积极分子学习园地'"   @click="()=>setSelcetList(a)">
                  <van-image fit="contain"   v-if="a.category=='积极分子学习园地'" src="/minio/gyfw/school/jjfzxx.png"/>
                  <van-image fit="contain"  v-if="a.category=='党员学习园地'" src="/minio/gyfw/school/dyxx.png"/>
                  <van-image fit="contain" v-if="a.category=='党委中心组学习园地'" src="/minio/gyfw/school/dzbxx.png"/>
                </div>
                <div class="contentchildItem" v-else>
                  {{ a.category }}
                </div>
              </div>
              <div v-if="!(a.category=='党员学习园地'||a.category=='党委中心组学习园地'||a.category=='积极分子学习园地')" class="contentchild" style="margin-top: 5px;">
                <div  v-for="c of [{ category: '全部', category_ids: a.child_list.map(m=>m.category_id).toString() }, ...a.child_list]"
                  :key="c.category_id"
                  @click="()=>selectChild(c, a.category)">
                  <div style="padding: 0px 4px;margin-top: 5px;" v-if="c.category=='党员学习园地'||c.category=='党委中心组学习园地'||c.category=='积极分子学习园地'">
                    <van-image fit="contain"   v-if="c.category=='积极分子学习园地'" src="/minio/gyfw/school/jjfzxx.png"/>
                    <van-image fit="contain"  v-if="c.category=='党员学习园地'" src="/minio/gyfw/school/dyxx.png"/>
                    <van-image fit="contain" v-if="c.category=='党委中心组学习园地'" src="/minio/gyfw/school/dzbxx.png"/>
                  </div>
                  <div v-else>
                    <div v-if="!c.cshow&&c.category!=='客服培训'"  class="contentchildItem">
                       {{ c.category }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
     <tab/>
  </div>
</template>
<script>
import Tab from './tab';
import { getInfo, recordRouter } from '@/api/shopapi';
const searchOpt = {
  use: false,
  category_id: 999999999,
  category: '搜索结果',
  child_list: []
}
export default {
  name: 'SchoolList',
  components: {
    Tab
  },
  data () {
    return {
      searched: false,
      activeKey: 0,
      searchResult: [],
      searchValue: '',
      infoList: [],
      parentName: '',
      child: null,
      selectList: null,
      selectValue:0,
      loading: false,
      sidestyle: { width: 'auto', position: 'relative', height: 'calc(100vh - 86px)',backgroundColor: '#f7f8fa', overflowY: 'scroll' }
    }
  },
  mounted() {
    this.changeAct()
  },
  watch: {
    '$route': {
      handler() {
        this.changeAct()
      },
      deep:true
    }
  },
  computed: {
    schoollist () {
      if (this.searched) {
        return [...this.$store.getters.getSchoolist, searchOpt]
      } else {
        console.log('getSchoolist',this.$store.getters.getSchoolist)
        return this.$store.getters.getSchoolist
      }
    },
    listarea () {
      if (searchOpt.use && this.activeKey === this.schoollist.length-1) {
        return []
      } else {
        const a = this.schoollist[this.activeKey].child_list.filter(f=>!f.child_list||f.child_list.length ===0)
        const b = this.schoollist[this.activeKey].child_list.filter(f=>f.child_list && f.child_list.length  > 0)

        if(b.length>0){
          b.map(v=>{
            if(v.category_id===20600){
              v.child_list.map(x=>{
                x.cshow=true
              })
            }
          })
        }
        return a.length > 0 ?[
          {
            category:this.schoollist[this.activeKey].category_id==20000?'公司内部培训材料': '精选',
            category_id: this.schoollist[this.activeKey].category_id,
            child_list: a
          },
          ...b
        ] : b
      }
    },
    selectOptions(){
      console.log('??112')
      if(this.selectList){
        console.log('??11')
        let arr=this.selectList.map(v=>{
          v.text=v.category
          v.value=v.category_id
          return v
        })

        arr.push({text:'全部',value:this.selectList[0].parent_id,category_id:this.selectList[0].parent_id})
        console.log('arr',arr)
        return arr
      }else {
        return []
      }
    }
  },

  methods: {
    changeAct () {
      const item = this.$route.params
      console.log('item',item)
      if(item && item.category_id) {
        console.log('111111111111')
        if(item.vip_id){
          this.selectChild(item,item.category)
        }else{
          this.activeKey = Math.max(0,this.schoollist.map(m=>m.category_id).indexOf(item.category_id))
        }

      }
    },
    onSearchJ () {
      this.$router.push({ name: "schoolSearch", params:  {
        category_id: null,
        stitle: this.searchValue,
        page_no: 0,
        page_size: 100000
      } });
    },
    async onSearch () {
      if(this.loading) {
        return
      }
      try {
        this.loading = true
        this.searched = true
        const res = await getInfo({
          category_id:  null,
          page_no: 0,
          page_size: 100000,
          title: this.searchValue
        })
        this.searchResult = res.data.data_list.map(m=>{
            m.bg = m.bg || '../../../static/img/bg/ept.jpg'
            return m
          })
        this.$nextTick(()=>{
          this.activeKey = this.schoollist.length - 1
          this.child = searchOpt
          this.infoList = [...this.searchResult]
        })
      } catch (e) {
        console.log(e)
      } finally {
        this.loading = false
      }
    },
    openVideo (info) {
      console.log('info', info)
      if (info.linktype === 4) {
        let para={
          method: null,
          url: info.url
        }
        recordRouter(para).then(res => {
          console.log('记录信息:', res)
        }).catch(error => {
          console.log(error);
        });
        location.href = info.url
      } else {
        this.$router.push({ name: "PlayVideo", params: info })
      }
    },
    onChange (index) {
      this.child = null
      this.selectList =null
      this.infoList = []
      this.activeKey = index
      if (searchOpt.use && this.activeKey === this.schoollist.length - 1) {
        this.$nextTick(()=>{
          this.child = searchOpt
          this.infoList = [...this.searchResult]
        })
      }

    },
    async selectChild (c, a) {
      console.log('ccccc',c)
      console.log('aaaaa',a)
      const res = await getInfo({
        category_ids: c.category_ids || null,
        category_id: c.category_id || null,
        page_no: 0,
        page_size: 100000
      })
      this.infoList = res.data.data_list.map(m=>{
        m.bg = m.bg || '../../../static/img/bg/ept.jpg'
        return m
      })
      this.child = c
      this.parentName = a || ''
    },
    async setSelcetList(x){
      console.log('xxxxxxxxxxxxx',x)
      this.selectList=x.child_list
      this.selectValue=x.category_id
      const res = await getInfo({
        category_ids: x.category_ids || null,
        category_id:  x.category_id || null,
        page_no: 0,
        page_size: 100000
      })
      console.log('res',res)

      this.infoList = res.data.data_list.map(m=>{
        m.bg = m.bg || '../../../static/img/bg/ept.jpg'
        return m
      })
    },
    async changeSelcet(){
      console.log(';xxxxx',this.selectValue)
      let obj=this.selectOptions.find(v=>{
        return v.category_id==this.selectValue
      })
      console.log(';xxxxx2',obj)
      const res = await getInfo({
        category_ids: obj.category_ids || null,
        category_id:  obj.category_id || null,
        page_no: 0,
        page_size: 100000
      })
      console.log('res',res)

      this.infoList = res.data.data_list.map(m=>{
        m.bg = m.bg || '../../../static/img/bg/ept.jpg'
        return m
      })
      // this.child = c
      // this.parentName = a || ''
    }
  }
}
</script>
<style>
.homes{
  background: transparent;
  width: 100%;
  display: flex;
  height: calc(100vh - 46px);
  padding-bottom: 46px;
  flex-direction: column;
}
.mySearchs{
  position: absolute;
  top: 0;
  width: 90%;
  background: transparent!important;
  left: 10%;
  font-size: 12px;
  z-index:101
}
.mySearchs .van-cell{
  padding: 0px!important;
}
.mySearchs .van-search__content {
  border: 1px solid red;
  border-radius: 25px;
}
.wrappers {
  position: relative;
  display: block;
  background-color: #f3f2f2;
  width: 100%;
  height: 100vh;
}
.contentlist {
  display: flex;
  position: relative;
  height: 100%;
  padding-top: 46px;
  flex-direction: row;
}
.contentarea {
  position: relative;
  flex: 1;
  height: calc(100vh - 92px);
  overflow-y: scroll;
  background-color: #fff;
}
.contentline {
  padding: 10px 0px 0px 40px;
  font-size: 0.37rem;
  line-height: 0.44rem;
  font-weight: 600;
}
.contentarea > .contentwrapper:nth-child(1) {
  padding-top: 10px;
}
.contentwrapper {
  padding-bottom: 20px;
  position: relative;
  display: block;
  width: 100%;
}
.contentline::before {
  display: block;
  position: absolute;
  color: red;
  text-align: center;
  font-weight: 500;
  font-size: 0.37rem;
  line-height: 0.37rem;
  height: 0.37rem;
  width: 40px;
  content: '●';
  left: 0px;
}
.contentchild {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  position: relative;
  width: 100%;
}
.contentchild  .contentchildItem {
  display: block;
  position: relative;
  margin: 4px 4px;
  padding: 4px 4px;
  border: 1px solid red;
  border-radius: 15px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  text-align: center;
  width: 20vw;
}
.vv-cardX {
  display: flex;
  height: 2rem;
  margin: 8px 8px;
  background-color:white;
}

.vv-cardX > div {
  flex: auto;
  height: auto;
}

.TStitleX {
  padding-top: 10px;
  /*padding-bottom: 8px;*/
  font-size: 0.3rem;
  line-height: 1.1;
  height: 1rem;
  /*overflow-y: hidden;*/
  word-break: break-all;
  /*flex: 1;*/
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  /*overflow: hidden;*/
  text-overflow: -o-ellipsis-lastline;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
 -webkit-box-orient: vertical;

}

.TScontentX {
  width: 65%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: 16px;
}

.TSImageX {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 35%;
  /* border: 1px solid rgb(119, 119, 119); */
}

.TSImageX > img {
  width: 100%;
  height: auto;
  display: block;
}

.TSDescX {
  display: flex;
  flex-direction: column;
  font-weight: lighter;
}
.djCover{
  height: 0;
}
#contentId .van-dropdown-item{
 left:80px!important;
}
.texte
{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
